import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeListItemWire } from '../types';

const mergePathWithList = (codes: CodeComplexValue<number>[], path: CodeComplexValue<number>): CodeComplexValue<number>[] => {

  if (!path || codes.some(code => code.value === path.value)) {
    return codes;
  }

  return [{
    ...path,
    descendants: mergePathWithList(codes, path.descendants && path.descendants[0])
  }];
};

export const mapListToStore = (codeItems: CodeListItemWire[], path: CodeComplexValue<number>): CodeComplexValue<number>[] => {

  const codeList = codeItems && codeItems
    .map(item => ({
      value: item.code && item.code.v,
      description: item.code && item.code.d,
      ...(item.code && item.code.ld && { longDescription: item.code.ld }),
      descendants: item.code && item.descendantCount ? [{ value: -1 }] : undefined,
      backgroundColor: item.decimalColour,
      ...(isDefinedIncludingZero(item?.uomTypeFrom?.v) && { uomTypeFrom: { value: item.uomTypeFrom.v, description: item.uomTypeFrom.d } }),
      ...(isDefinedIncludingZero(item?.uomTypeTo?.v) && { uomTypeTo: { value: item.uomTypeTo.v, description: item.uomTypeTo.d } })
    })) || [] as CodeComplexValue<number>[];

  return mergePathWithList(codeList, path);
};
